import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import CustomDatePicker from '../common/CustomDatePicker';
import Button from '../common/Button';
import {BiUser, BiCalculator, BiBarChartSquare, BiMessageAltDetail, BiMobileAlt, BiSearch, BiDockTop} from 'react-icons/bi';
import {RiCoupon2Line} from 'react-icons/ri';
import palette from '../../lib/styles/palette';
import TableScrollbar from 'react-table-scrollbar';
import { FaMobileAlt } from 'react-icons/fa';

const NavBar = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    background: #fff;
    border: 1px solid #e0e4ea;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 10px 16px;
`;

const NavWrap = styled.ul`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;

    & li {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;
        border-radius: 20px;
        padding: 10px 18px;
        min-width: 140px;
        font-size: 0.92rem;
        font-weight: 600;
        color: ${palette.webGray[6]};
        cursor: pointer;
        transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;

        & svg {
            font-size: 1.25rem;
            margin-right: 8px;
            transition: color 0.15s ease;
        }

        &:hover {
            color: ${palette.webCyan[5]};
            background: #f8f9fb;
            border-color: #e0e4ea;
        }

        &.active {
            color: #fff;
            font-weight: 700;
            background: ${palette.webCyan[5]};
            border-color: ${palette.webCyan[5]};

            & svg {
                color: #fff;
            }
        }
    }
`;

const AdminNavBar = ({page, setPage}) => {

    let history = useHistory();
    
    const movePage = (page) => {
        setPage(page);
    }

    return(
        <NavBar>
            <NavWrap>
                <li onClick={() => {
                    if(page!="clubtransfermoney") movePage("clubtransfermoney")
                }} className={page=="clubtransfermoney" ? "active" : ""}><BiBarChartSquare />클럽 자동이체 결과</li>
                <li onClick={() => {
                    if(page!="clubctransferalculate") movePage("clubctransferalculate")
                }} className={page=="clubctransferalculate" ? "active" : ""}><BiCalculator />클럽 정산</li>
                <li onClick={() => {
                    if(page!="clubmobileauth") movePage("clubmobileauth")
                }} className={page=="clubmobileauth" ? "active" : ""}><BiMobileAlt />클럽 모바일 판매</li>
                <li onClick={() => {
                    if(page!="clubsms") movePage("clubsms")
                }} className={page=="clubsms" ? "active" : ""}><FaMobileAlt />문자</li>
                <li onClick={() => {
                    if(page!="clubsetting") movePage("clubsetting")
                }} className={page=="clubsetting" ? "active" : ""}><RiCoupon2Line />클럽 설정</li>
                <li onClick={() => {
                    if(page!="centersetting") movePage("centersetting")
                }} className={page=="centersetting" ? "active" : ""}><BiDockTop />센터 설정</li>
                <li onClick={() => {
                    if(page!="clubrunningtrackinfo") movePage("clubrunningtrackinfo")
                }} className={page=="clubrunningtrackinfo" ? "active" : ""}><RiCoupon2Line />제타트랙 설정</li>
                <li onClick={() => {
                    if(page!="clubadminsearch") movePage("clubadminsearch")
                }} className={page=="clubadminsearch" ? "active" : ""}><BiSearch />회원 검색</li>
                <li onClick={() => {
                    if(page!="trapappstats") movePage("trapappstats")
                }} className={page=="trapappstats" ? "active" : ""}><BiBarChartSquare />트랩앱 통계</li>
                {/* <li onClick={() => {
                    if(page!="clubcoupon") movePage("clubcoupon")
                }} className={page=="clubcoupon" ? "active" : ""}><RiCoupon2Line />트랩 쿠폰</li> */}
                {/* <li onClick={() => {
                    if(page!="message") movePage("message")
                }} className={page=="message" ? "active" : ""}><BiMessageAltDetail />알림</li>
                <li onClick={() => {
                    if(page!="banner") movePage("banner")
                }} className={page=="banner" ? "active" : ""}><BiDockTop />배너</li> */}
            </NavWrap>
            {/* <NavWrap>
                <li onClick={() => {
                    if(page!="landing") movePage("landing")
                }} className={page=="landing" ? "active" : ""}><BiFileBlank />페이지 제작</li>
                <li onClick={() => {
                    if(page!="imageTemplate") movePage("imageTemplate")
                }} className={page=="imageTemplate" ? "active" : ""}><BiImageAlt />이미지 제작</li>
            </NavWrap> */}
        </NavBar>
    )
};

export default AdminNavBar;
